// extracted by mini-css-extract-plugin
module.exports = {"form":"thongTinBenhNhan_form__21JEk","wrapper":"thongTinBenhNhan_wrapper__zULL4"};